import React from 'react'
import styled from 'styled-components'
import { ReactComponent as Neutral } from "../../Assets/iconsv2/moodIcons/neutral.svg"
import { ReactComponent as Romantic } from "../../Assets/iconsv2/moodIcons/romantic.svg"
import { ReactComponent as Humorous } from "../../Assets/iconsv2/moodIcons/humorous.svg"
import { ReactComponent as Casual } from "../../Assets/iconsv2/moodIcons/casual.svg"
import { ReactComponent as Supportive } from "../../Assets/iconsv2/moodIcons/supportive.svg"
import { ReactComponent as Business } from "../../Assets/iconsv2/moodIcons/business.svg"
import { ReactComponent as Formal } from "../../Assets/iconsv2/moodIcons/formal.svg"
import { BUSINESS_MOOD, CASUAL_MOOD, FORMAL_MOOD, HUMOROUS_MOOD, NEUTRAL_MOOD, ROMANTIC_MOOD, SUPPORTIVE_MOOD } from '../../Constants/constantValues'
import { colors } from '../../Assets/styles/colors'
import { useTranslate } from '@tolgee/react';

const MessageMood = ({ mood, onClick }) => {

    const displayMoodIcon = () => {
        let returnMood = <Neutral />
        switch (mood) {
            case ROMANTIC_MOOD:
                returnMood = <Romantic />
                break;
            case HUMOROUS_MOOD:
                returnMood = <Humorous />
                break;
            case CASUAL_MOOD:
                returnMood = <Casual />
                break;
            case SUPPORTIVE_MOOD:
                returnMood = <Supportive />
                break;
            case BUSINESS_MOOD:
                returnMood = <Business />
                break;
            case FORMAL_MOOD:
                returnMood = <Formal />
                break;
            default:
                break;
        }

        return returnMood
    }
    const { t } = useTranslate();
    return (
        <Container>
            <CustomButton onClick={onClick}>
                {displayMoodIcon()}
                {t('settings.style')}
            </CustomButton>
        </Container>
    )
}

export default MessageMood
const Container = styled.div`
display:flex;
align-items:center;
justify-content:center;

`
const CustomButton = styled.button`
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;
border:none;
background:none;
cursor:pointer;
color:${({ theme }) => theme.chat.readIconColor};
opacity:0.7;
svg{
fill:rgba(142, 146, 154, 1);
}
`